import { NgZone } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { ValidStateChangeEvent } from '../../services/copy-and-paste/valid-state-emitter';

export class ButtonState {
  private _state = false;
  private _subscription: Subscription;

  constructor(initialState: boolean, validStateChange$: Observable<ValidStateChangeEvent>, zone: NgZone) {
    this._state = initialState;
    this._subscription = validStateChange$.subscribe((validState) =>
      zone.run(() => {
        this._state = validState.valid;
      })
    );
  }

  get state(): boolean {
    return this._state;
  }

  unsubscribe(): void {
    this._subscription?.unsubscribe();
  }
}

export class TooltipState {
  private static PRE_FADE_PAUSE_MS = 200;
  private _visible = false;
  private _subscription: Subscription;

  constructor(action$: Observable<void>, zone: NgZone) {
    this._subscription = action$
      .pipe(
        tap((_) => zone.run(() => (this._visible = true))),
        delay(TooltipState.PRE_FADE_PAUSE_MS),
        tap((_) => zone.run(() => (this._visible = false)))
      )
      .subscribe();
  }

  get visible(): boolean {
    return this._visible;
  }

  unsubscribe(): void {
    this._subscription?.unsubscribe();
  }
}

export class ToolButton {
  private readonly _action: () => void;
  private readonly _buttonState: ButtonState;
  private readonly _tooltipState: TooltipState;

  constructor(action: () => void, buttonState: ButtonState, tooltipState: TooltipState) {
    this._action = action;
    this._buttonState = buttonState;
    this._tooltipState = tooltipState;
  }

  get validState(): boolean {
    return this._buttonState.state;
  }

  get tooltipVisible(): boolean {
    return this._tooltipState.visible;
  }

  action(): void {
    this._action();
  }

  unsubscribe(): void {
    this._buttonState.unsubscribe();
    this._tooltipState.unsubscribe();
  }
}
